import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=8a996606&"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js&"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports